import React, { useEffect } from "react";
import Column from "components/ui/layout/column/column";
import CardBox from "components/ui/controls/card-box/card-box";
import Row from "components/ui/layout/row/row";
import { applyFormat } from "components/ui/ui-helpers";
import StackedBarChart from "components/ui/controls/stacked-bar-chart/StackedBarChart";

const StackedLegend = ({ items }) => {
  return (
    <div
      style={{
        padding: "20px",
        backgroundColor: "#ffffff",
        borderRadius: "12px",
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.05)",
        border: "1px solid #e5e7eb",
        marginBottom: "20px",
        height: "200px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <h4
        style={{
          fontSize: "14px",
          fontWeight: "600",
          color: "#1f2937",
          marginBottom: "20px",
          textAlign: "center",
        }}
      >
        Légende
      </h4>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "12px",
        }}
      >
        {items.map((item, index) => (
          <div
            key={index}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              padding: "8px 12px",
              borderRadius: "8px",
              backgroundColor: "#f9fafb",
            }}
          >
            <div
              style={{
                width: "16px",
                height: "16px",
                borderRadius: "4px",
                backgroundColor: item.color,
                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
              }}
            ></div>
            <span
              style={{
                fontSize: "12px",
                fontWeight: "500",
                color: "#374151",
              }}
            >
              {item.label}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

const DetailInvaliditeTNS = ({ Outil, GraphInval, TabInval, Affichage }) => {
  useEffect(() => {
    document.getElementById("GraphInval").innerHTML = GraphInval;
  }, [GraphInval]);

  const getIconStyle = (category) => {
    if (category.includes("33%")) return { emoji: "%", background: "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)" };
    if (category.includes("66%")) return { emoji: "%", background: "linear-gradient(135deg, #ea580c 0%, #c2410c 100%)" };
    if (category.includes("100%")) return { emoji: "%", background: "linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)" };
    return { emoji: "%", background: "linear-gradient(135deg, #374151 0%, #1f2937 100%)" };
  };

  const chartData = [
    { label: "Net perçu", obligatoire: 100, facultatif: 0, perteRevenu: 0 },
    ...TabInval.map((data) => {
      const label = data.category ? data.category.replace(/<br>/g, " ") : "";
      const obligatoire = Math.max(0, data["TauxRempInvalObligatoire"]);
      const facultatif = Math.max(0, data["TauxRempInvalFacultatif"]);
      const perteRevenu = Math.max(0, 100 - obligatoire - facultatif);
      return { label, obligatoire, facultatif, perteRevenu };
    }),
  ];

  const chartColors = ["#3b82f6", "#10b981", "#9ca3af"];

  const legendItems = [
    { label: "Régime obligatoire", color: chartColors[0] },
    { label: "Régime facultatif", color: chartColors[1] },
    { label: "Perte de revenu", color: chartColors[2] },
  ];

  return (
    <Column fill>
      <CardBox>
        <Column fill>
          <Row bpad>
            <div className="cotisations-container">
              <div className="cotisations-list-container">
                <div className="cotisations-header">
                  <div className="header-column"></div>
                  <div className="header-column">Catégorie</div>
                  <div className="header-column">Régime(s) obligatoire(s)</div>
                  <div className="header-column">Régime(s) facultatif(s)</div>
                  <div className="header-column">Total</div>
                </div>

                {TabInval.map((data, i) => {
                  const iconStyle = getIconStyle(data.category || (i === 1 ? "33%" : i === 2 ? "66%" : i >= 3 ? "100%" : ""));
                  const category = i === 0 ? data.category : i === 1 ? "33%" : i === 2 ? "66%" : i === 3 ? "100%" : "100% + majo. tierce pers.";

                  return (
                    <div key={i} className="cotisations-card">
                      <div className="cotisations-card-icon" style={{ background: iconStyle.background, fontSize: "10px" }}>
                        {iconStyle.emoji}
                      </div>
                      <div className="card-column">{category}</div>
                      <div className="card-column">{applyFormat(Math.max(0, data["Régime obligatoire"]), "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
                      <div className="card-column">{applyFormat(Math.max(0, data["Régime facultatif"]), "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
                      <div className="card-column">{applyFormat(Math.max(0, data["Régime obligatoire"] + data["Régime facultatif"]), "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
                    </div>
                  );
                })}
              </div>
            </div>
          </Row>

          <Row style={{ gap: "20px", alignItems: "flex-start", marginTop: "20px" }}>
            <Column style={{ flex: 2 }}>
              <div style={{ position: "relative" }}>
                <StackedBarChart title="Prestations d'invalidité par catégorie" data={chartData} colors={chartColors} variant="tube" referenceValue={100} />
                <div id="GraphInval" style={{ display: "none" }}></div>
              </div>
            </Column>

            <Column style={{ flex: 1 }}>
              <StackedLegend items={legendItems} />
            </Column>
          </Row>
        </Column>
      </CardBox>
    </Column>
  );
};

export default DetailInvaliditeTNS;
